import { useMutation } from "@shared/lib/hooks";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";
import {
  ICreateDeliverableFormat,
  IUpdateDeliverableFormat,
} from "@shared/lib/types";
import { DELIVERABLE_CONFIGURATOR_QUERY_KEY } from "../constants";

export default function useUpdateDeliverableFormat() {
  const {
    mutate: updateDeliverableFormat,
    isLoading: isUpdateDeliverableFormatLoading,
    error: updateDeliverableFormatError,
    isSuccess: isUpdateDeliverableFormatSuccess,
    variables: updateDeliverableFormatVariables,
  } = useMutation({
    mutationFn: (data: IUpdateDeliverableFormat) =>
      DeliverableConfiguratorService.updateDeliverableFormat(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...DELIVERABLE_CONFIGURATOR_QUERY_KEY],
      });
    },
  });

  return {
    updateDeliverableFormat,
    isUpdateDeliverableFormatLoading,
    isUpdateDeliverableFormatSuccess,
    updateDeliverableFormatError,
    updateDeliverableFormatVariables,
  };
}
